/* eslint-disable max-len */
import register from '../register';
import dom from './util/dom';
import birthdateMask from './util/birthdate-mask';

let validators = {
  birthdate: validateBirthdate,
  confirm_recurring: Boolean,
  confirm_transfer: Boolean,
  confirm_pii: Boolean,
  confirm_transfer_in: Boolean,
  electronic_signature: validateElectronicSignature
};

class ACPRequestForm {

  constructor( context ) {
    this.form   = context.querySelector('.acp-request-form');
    this.inputs = [ ...this.form.querySelectorAll('input:not([type="radio"])') ];
    this.submit = context.querySelector('.inp-submit');
    this.result = context.querySelector('.form-result');

    this.birthdate = this.form.querySelector('.inp-birthdate');
    this.user_id   = this.form.querySelector('.inp-user_id');
    this.radios = [ ...this.form.querySelectorAll('input[type="radio"]') ];

    this.onSubmit   = this.onSubmit.bind( this );
    this.getPayload = this.getPayload.bind( this );
    this.submitForm = this.submitForm.bind( this );
    this.onSuccess  = this.onSuccess.bind( this );

    birthdateMask( this.birthdate );

    this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener( 'submit', this.onSubmit, false );
  }

  scrollToFirstError() {
    const el = document.querySelectorAll('.inp-group.error')[ 0 ];
    const rect = el.getBoundingClientRect();
    const offset = 80; // account for header height
    const top = rect.top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  onSubmit( e ) {
    e.preventDefault();

    if ( this.validate() ) {
      this.submit.disabled = true;
      this.submit.classList.add('loading');

      const payload = this.getPayload();

      payload.birthdate = validateBirthdate( payload.birthdate );

      this.submitForm( payload );
      return false;
    }

    this.scrollToFirstError();
    return false;
  }

  validate() {
    let radioValid = true;
    let radioGroups = this.radios.reduce( groupRadiosByName, {} );

    for ( let name of Object.keys( radioGroups ) ) {
      const errorClass = 'error';
      const parent = radioGroups[ name ][ 0 ].closest('.inp-group');
      const required = radioGroups[ name ].some( shouldValidate );
      const valid = radioGroups[ name ].some( inp => inp.checked );

      parent.classList.remove( errorClass );

      if ( required && !valid ) {
        parent.classList.add( errorClass );
        radioValid = false;
      }
    }

    return !this.inputs
    .filter( shouldValidate )
    .map( removeError )
    .filter( isInvalid )
    .map( addError ).length && radioValid;
  }

  getPayload() {
    const radios = this.radios.reduce( getRadiosVal, {} );
    const inputs = this.inputs
    .filter( isNotSubmit )
    .reduce( inputReducer, {} );

    return Object.assign( {}, inputs, radios );
  }

  submitForm( payload ) {
    dom.ajax(
      {
        url: this.form.getAttribute('action'),
        method: 'POST'
      },
      payload,
      ( err, res ) => {
        if ( err ) {
          return this.onError( err );
        }
        this.onSuccess( res );
      }
    );
  }

  onSuccess() {
    this.submit.classList.remove('loading');
    this.result.classList.remove('error');
    this.result.classList.add('success');

    this.result.textContent = 'Your request has been processed.';
  }

  onError( err ) {
    this.submit.disabled = false;
    this.submit.classList.remove('loading');
    this.result.classList.add('error');
    this.result.classList.remove('success');

    const xhr = err.xhr;

    let payload = {};
    let message = 'An error occurred. Please try again.';

    try {
      payload = JSON.parse( xhr.responseText );
    } catch ( e ) {}

    switch ( payload.reason ) {
      case 'program_ended':
        message = 'Sorry, Starry is no longer processing new ACP enrollments';
        break;
      case 'already_processed':
        message = 'Your request has already been processed.';
        break;
      case 'not_eliglble':
        message = 'Sorry, your address is not eligible.';
        break;
      case 'already_discounted':
        message = 'Sorry, the ACP program cannot be combined with other discounts.';
      case 'excluded_market':
        message = 'Sorry, Starry does not yet participate in the ACP in your area, but we\'ll email eligible users when we\'re ready for you to sign up.';
        break;
    }

    this.result.textContent = message;
  }

}

function init() {
  const ctx = document.querySelector('body.acp');
  new ACPRequestForm( ctx );
}

function validateBirthdate( str ) {
  const match = str.match( /^([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})$/ );

  if ( !match ) {
    return false;
  }

  const latest   = new Date;
  const earliest = new Date('1900-01-01');
  const date     = new Date( str );

  // sanity check foir valid dates
  if ( !( date >= earliest && date < latest ) ) {
    return false;
  }

  const pad = n => n > 9 ? n : `0${ Number( n ) }`;
  const [ y, m, d ] = str.split('-').map( pad );

  return `${ y }-${ m }-${ d }`;
}

function validateElectronicSignature( str ) {
  return str && str.length;
}

function addError( inp ) {
  const parent = inp.closest('.inp-group');
  parent.classList.add('error');
  return inp;
}

function removeError( inp ) {
  const parent = inp.closest('.inp-group');
  parent.classList.remove('error');
  return inp;
}

function shouldValidate( inp ) {
  return inp.dataset.validate !== undefined;
}

function isEmpty( inp ) {
  return !inp.value || inp.value === 'none';
}

function isInvalid( inp ) {
  const validate = validators[ inp.dataset.validate ];
  const value = inp.type === 'checkbox' ? inp.checked : ( inp.value || '' );
  return typeof validate === 'function' ? !validate( value ) : isEmpty( inp );
}

function isNotSubmit( inp ) {
  return inp.type !== 'submit';
}

function inputReducer( obj, inp ) {
  // eslint-disable-next-line max-len
  obj[ inp.name ] = inp.type === 'checkbox' ? inp.checked : ( inp.value || null );
  return obj;
}

function getRadiosVal( obj, inp ) {
  obj[ inp.name ] = inp.checked ? inp.value : obj[ inp.name ];
  return obj;
}

function groupRadiosByName( obj, inp ) {
  if ( !obj.hasOwnProperty( inp.name ) ) {
    obj[ inp.name ] = [];
  }
  obj[ inp.name ].push( inp );
  return obj;
}

register( 'acp-request-form', init );

// eslint-disable-next-line no-undef
export default undefined;
